import { Box, Paper, styled } from "@mui/material"

export const Content = styled(Box)(() => ({}))

export const Card = styled(Paper)`
  box-shadow: 12px 14px 23px -2px rgb(0 0 0 / 3%);
  border-radius: 26px;
  margin-top: 35px;
  padding: 51px 10px 48px;
  text-align: center;
`
